export const CONFLICT_ERROR = "Request failed with status code 409";
